import { useState, useEffect } from 'react'
import { localeHeader } from '#constants'
import qs from 'qs'
import platformClient from '#lib/platform-client'
import { useRouter } from 'next/router'
import { fireProductListImpressionEvent } from '#src/common/lib/events/publishers/analytics/fire-events/product-list-impression-event'

const getProductsByCategory = async (categoryId, query, locale) => {
  return platformClient(`/products/by-category/${categoryId}${query}`, {
    version: 'v3',
    headers: {
      [localeHeader]: locale
    }
  })
}

const getProducts = async (category, query, locale) => {
  if (category.subcategories?.length) {
    await Promise.all(
      category.subcategories.map(async (subcategory, index) => {
        const products = await getProductsByCategory(
          subcategory.id,
          query,
          locale
        )
        category.subcategories[index].products = products
      })
    )
  } else {
    category.products = await getProductsByCategory(category.id, query, locale)
  }
  return category
}

export const useCategoryData = ({
  selectedCategory,
  selectedSubCategory,
  isTransactional,
  bag
}) => {
  const { locale } = useRouter()
  const [categoryData, setCategoryData] = useState({
    category: selectedCategory,
    isLoading: false,
    error: null
  })

  useEffect(() => {
    if (!isTransactional && selectedCategory) {
      setCategoryData({
        category: selectedCategory,
        isLoading: false,
        error: null
      })
      fireProductListImpressionEvent(selectedCategory, selectedSubCategory)
    }
  }, [isTransactional, selectedCategory, selectedSubCategory])

  const { isLoading, orderDetails } = bag || {}
  const {
    pickupTimeStart,
    pickupTimeEnd,
    fulfillingShopId: shopId,
    orderType
  } = orderDetails || {}

  const handleErrors = error => {
    setCategoryData({
      ...categoryData,
      category: null,
      isLoading: false,
      error: error.response
    })
  }

  useEffect(() => {
    async function fetchProductsByCategories() {
      if (!isLoading && pickupTimeStart && pickupTimeEnd && shopId) {
        const query = {
          pickupTimeStart,
          pickupTimeEnd,
          shopId,
          orderType
        }
        const queryString = `?${qs.stringify(query)}` || ''
        try {
          setCategoryData({ ...categoryData, isLoading: true })
          const result = await getProducts(
            selectedCategory,
            queryString,
            locale
          )
          if (result) {
            setCategoryData({
              error: null,
              category: result,
              isLoading: false
            })
            fireProductListImpressionEvent(
              selectedCategory,
              bag.orderDetails?.fulfillingShopType
            )
          }
        } catch (error) {
          handleErrors(error)
        }
      }
    }
    if (bag && isTransactional) {
      setCategoryData({ ...categoryData, isLoading: isLoading })
      fetchProductsByCategories()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isLoading,
    pickupTimeStart,
    pickupTimeEnd,
    shopId,
    selectedCategory,
    isTransactional,
    locale
  ])
  return categoryData
}
